import React from "react";
import { Grid } from "@mui/material";

const DashboardPage: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={7}></Grid>
      <Grid item xs={5}></Grid>
    </Grid>
  );
};

export default DashboardPage;
